import ErrorPage from './default';
import { INCOMPATIBLE_LMA as TEXTS } from './constants';

function IncompatibleAdditionalFiberErrorPage(props) {
  return (
    <ErrorPage
      {...props}
      title={TEXTS.TITLE}
      description={TEXTS.DESCRIPTION}
      iconColor="BLUE"
      iconId="informacion"
      buttonText={TEXTS.BUTTON_TEXT}
      buttonHref={TEXTS.BUTTON_HREF}
      showLink={false}
      componentContent="incompatible-lma"
    />
  );
}
export default IncompatibleAdditionalFiberErrorPage;
